import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { DEFAULT_PAGE_SIZE } from '../../../utils/contants';

export const bulkUploadApi = createApi({
    reducerPath: 'bulkUploadApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
        credentials: 'include'
    }),
    endpoints: (builder) => ({
        uploadBulkCSV: builder.mutation({
            query: (formData) => ({
                url: 'bulk-upload',
                method: 'POST',
                body: formData
            })
        }),
        listBatches: builder.mutation({
            query: ({ page = 1, limit = DEFAULT_PAGE_SIZE } = {}) => ({
                url: `bulk-upload?page=${page}&limit=${limit}`,
                method: 'GET'
            })
        }),
        getBatchMessages: builder.mutation({
            query: (batchId) => ({
                url: `bulk-upload/${batchId}/messages`,
                method: 'GET'
            })
        }),
        getSampleCSV: builder.mutation({
            query: () => ({
                url: 'bulk-upload/sample-csv',
                method: 'GET',
                responseHandler: (response) => response.text()
            })
        })
    })
});

export const {
    useUploadBulkCSVMutation,
    useListBatchesMutation,
    useGetBatchMessagesMutation,
    useGetSampleCSVMutation
} = bulkUploadApi;
